import request from '@/utils/request'

/**
 * 查询店铺审核详情
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopAudit(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopAudit.queryShopAudit',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 提交店铺审核
 * @param {Object} data 提交数据
 * @returns {Promise} Promise对象
 */
export function auditEditShop(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.auditEditShop',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}